module.exports = __webpack_public_path__ + "static/img/PC-1.c8b952f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcgaofu/PC-1.png
// module id = OLEq
// module chunks = 0